module.exports = __webpack_public_path__ + "static/img/no-data.fd973d3c.png";